var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4297 26.2421C43.516 26.2421 43.9695 24.8464 43.0871 24.2031L29.6609 14.4367C29.4692 14.2962 29.2377 14.2205 29 14.2205C28.7623 14.2205 28.5308 14.2962 28.3391 14.4367L14.9129 24.2031C14.0305 24.8429 14.484 26.2421 15.5738 26.2421H17.75V39.3906H15.2188C15.0641 39.3906 14.9375 39.5171 14.9375 39.6718V41.5C14.9375 41.6546 15.0641 41.7812 15.2188 41.7812H42.7813C42.9359 41.7812 43.0625 41.6546 43.0625 41.5V39.6718C43.0625 39.5171 42.9359 39.3906 42.7813 39.3906H40.25V26.2421H42.4297ZM29 16.9152L38.5309 23.848H19.4691L29 16.9152ZM20.2813 26.2421H24.3945V39.3906H20.2813V26.2421ZM26.9258 26.2421H31.0391V39.3906H26.9258V26.2421ZM37.7188 39.3906H33.5703V26.2421H37.7188V39.3906Z",
    fill: "#179CF0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 28.5,
    stroke: "#179CF0",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.43336e22c9db6488830e7b02eaedb3dc.svg";
export { ForwardRef as ReactComponent };